import React, { Component } from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Breadcrumb } from "antd";

import "antd/lib/breadcrumb/style"
import "./VhBreadcrumb.scss";

/**
 * 面包屑路由
 *
 * @export
 * @interface VhBreadcrumbRoute
 */
export interface VhBreadcrumbRoute {
  /**
   * 路由名称
   *
   * @type {string}
   * @memberof VhBreadcrumbRoute
   */
  breadcrumbName: string;
  /**
   * 路由链接
   *
   * @type {string}
   * @memberof VhBreadcrumbRoute
   */
  path?: string;
  /**
   * 路由参数
   *
   * @type {{[key: string]: any}}
   * @memberof VhBreadcrumbRoute
   */
  params?: {[key: string]: any};
  /**
   * 参数类型
   *
   * @type {("search" | "hash" | "state")}
   * @memberof VhBreadcrumbRoute
   */
  type?: "search" | "hash" | "state";
}

/**
 * 面包屑属性
 *
 * @export
 * @interface VhBreadcrumbProps
 */
export interface VhBreadcrumbProps {
  /**
   * 路由
   *
   * @type {VhBreadcrumbRoute[]}
   * @memberof VhBreadcrumbProps
   */
  routes: VhBreadcrumbRoute[]
}

// 合并props
type AllProps = VhBreadcrumbProps & RouteComponentProps;

/**
 * 面包屑公共组件
 *
 * @class VhBreadcrumb
 * @extends {React.Component<AllProps>}
 */
class VhBreadcrumb extends Component<AllProps> {
  public render() {
    return (
      <Breadcrumb className="vh-breadcrumb" separator="-">
        {
          this.props.routes && this.props.routes.map((item: VhBreadcrumbRoute, index: number) => (
            <Breadcrumb.Item key={ index }>
              {
                item.path ? <Link to={ {pathname: item.path, state: item.params} }>{ item.breadcrumbName }</Link> : item.breadcrumbName
              }
            </Breadcrumb.Item>
          ))
        }
      </Breadcrumb>
    )
  }
}

export default withRouter(VhBreadcrumb);
